<template>
  <div>
    <span v-for="business in businesses" :key="business.id">
      {{ business.name }}
      <span>{{ getSeparator(business.id) }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    businesses: {
      type: Array,
      required: false,
      default: function() {
        return []
      }
    }
  },
  methods: {
    getSeparator(businessId) {
      const index = this.businesses.findIndex(x => x.id === businessId)
      const nextIndex = index + 1
      const lastIndex = this.businesses.length - 1

      if (nextIndex <= lastIndex) {
        if (nextIndex === lastIndex) {
          return ' ' + this.$t('and') + ' '
        }
        return ', '
      }
      return ''
    }
  }
}
</script>
